import { AppConfig } from '../Models';

const CONFIG_FILE: string = `${process.env.PUBLIC_URL}/config.json`;

export const getAppConfigData = (): Promise<AppConfig> => {
  return fetch(CONFIG_FILE, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
    .then((response) => response.json())
    .then((faqsJson) => faqsJson as AppConfig);
};
